import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export interface SectionHeaderProps {
  title: string;
  /** Optional right-hand slot for a link or status chip. */
  action?: ReactNode;
  description?: string;
  className?: string;
}

export function SectionHeader({ title, action, description, className }: SectionHeaderProps) {
  return (
    <div className={cn('mb-3.5 flex items-start justify-between gap-3', className)}>
      <div>
        <h2 className="text-[15px] font-bold tracking-[-0.4px]">{title}</h2>
        {description ? (
          <span className="font-mono text-[11px] text-content-muted">{description}</span>
        ) : null}
      </div>
      {action}
    </div>
  );
}
